import NavBar from "../../components/NavBar/NavBar"
import Footer from "../../components/Footer/Footer"
import Title from "../../components/Title/Title"
import Card from "../../components/Card/Card"
import CircleCard from "../../components/Circle-Card/Circle-Card"

export default function Benedict() {
    return (
        <div>
            <NavBar/>
            <Title text={"São Bento e Sua Medalha"}/>                

            <CircleCard imagem={"https://i.pinimg.com/736x/4a/d9/4e/4ad94e1ccf05dc4df776c5a881864a4f.jpg"} />

      <div className="card-container">
            <Card Nome={"São Bento de Núrsia"} Descricao={""} Imagem={"https://nsykpvjwslvdnfbknhmm.supabase.co/storage/v1/object/public/church/Symbols/SB_Medal.jpg"}/>

    </div>

        
        <Footer/>
        </div>
    )
}